import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { UpdateRBLSettingsBody } from '../@types/practices';
import { makeAPIRequestV2 } from '../utils/api';

import { endpoints } from './endpoints';

export const useUpdateRBLSettings = () => {
  const user = useSelector((state: any) => state.login.user);

  return useMutation((updateRBLSettingsBody: UpdateRBLSettingsBody) => {
    return makeAPIRequestV2(
      `/${endpoints.organizations}/${user.primaryOrganizationId}/${endpoints.practice}/${user.primaryPracticeId}/${endpoints.rblSettings}`,
      { data: updateRBLSettingsBody },
      'PUT',
    );
  });
};
